const { REACT_APP_API_BASE_URL } = process.env;

export const getSignedUrl = (token, fileName) => new Promise((resolve, reject) => {
  const queryParams = new URLSearchParams({
    file: fileName.substring(1)
  }).toString();

  const request = new Request(
    `${REACT_APP_API_BASE_URL}/utils/generate-signed-url?${queryParams}`,
    {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
  );

  fetch(request)
    .then(async (response) => {
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Error al obtener URL');
      }
      return response.json();
    })
    .then(data => resolve(data.url))
    .catch(err => reject(err));
});
